<div class="modal-header">
  <h4>{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()">
    <svg-icon class="notification-icon" src="assets/icons/cancel.svg"></svg-icon>
  </button>
</div>
